
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/videos/[id]",
      function () {
        return require("private-next-pages/videos/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/videos/[id]"])
      });
    }
  